<template>
    <main class="main login">
        <div class="login-image">
            <img
                class="login-image-img"
                :src="require(`@/assets/img/${$brand.logo.welcomeImg}`)"
            />
        </div>
        <div class="container">
            <div class="row">
                <div class="col-md-6 offset-md-6 login-col">
                    <form
                        class="ml-md-5 login-form"
                        @submit.prevent="handleLoginFormSubmit"
                    >
                        <h1 class="h3">Zaloguj się do serwisu</h1>
                        <p class="my-4" v-html="$brand.login.subTitle"></p>
                        <the-input
                            id="mp-email"
                            class="cux-exclude mb-4"
                            :label="'Wpisz swój adres e-mail/login'"
                            :name="'mp-email'"
                            @input="login.username = $event"
                            :text="login.username"
                        ></the-input>
                        <the-input
                            id="mp-pass"
                            class="cux-exclude"
                            :type="'password'"
                            :label="'Wpisz swoje hasło'"
                            :name="'mp-password'"
                            @input="login.password = $event"
                            :text="login.password"
                        ></the-input>
                        <div class="form-group">
                            <ui-checkbox-input
                                name="selectAllPromos"
                                label="Pozostań zalogowany"
                                v-model="login.stay_logged"
                            />
                        </div>
                        <p class="text-right text-sm">
                            Nie pamiętasz hasła?
                            <router-link
                                class="font-weight-bold text-sm"
                                to="/pass-reset"
                                >Zresetuj hasło</router-link
                            >
                        </p>

                        <the-btn
                            id="login"
                            class="mt-4 text-white btn-block btn-secondary"
                            :text="'Logowanie'"
                            :disabled="!login.username || !login.password"
                        ></the-btn>
                        <p
                            class="text-center text-sm mt-3"
                            v-if="$brand.login.joinToPlatform"
                        >
                            <a
                                class="text-dark  cursor-pointer"
                                v-tooltip="
                                    $brand.login.joinToPlatform.tooltipText
                                "
                                >{{ $brand.login.joinToPlatform.title }}</a
                            >
                        </p>

                        <div v-if="isCaptcha" id="recaptcha-container" />

                        <div v-if="isCaptcha" class="recaptcha-info">
                            Ta strona jest chroniona przez reCAPTCHA i Google
                            <a href="https://policies.google.com/privacy">
                                Polityka prywatności</a
                            >
                            <a href="https://policies.google.com/terms">
                                Warunki korzystania z usługi</a
                            >
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </main>
</template>

<script>
import axios from 'axios'

export default {
    data() {
        return {
            login: {
                username: '',
                password: '',
                stay_logged: true
            }
        }
    },
    mounted() {
        if (this.isCaptcha) {
            const recaptchaScript = document.createElement('script')
            recaptchaScript.setAttribute(
                'src',
                `https://www.google.com/recaptcha/api.js?render=${process.env.VUE_APP_RECAPTCHA_SITE_KEY}`
            )
            document.head.appendChild(recaptchaScript)
        }
    },
    computed: {
        isDevelopment() {
            return process.env.NODE_ENV === 'development'
        },
        isCaptcha() {
            return !this.isDevelopment
        }
    },
    methods: {
        async handleLoginFormSubmit() {
            if (!this.login.username || !this.login.password) {
                return
            }

            await this.$store.dispatch('authRemove')
            const self = this

            const requestBody = {
                login: self.login.username,
                password: self.login.password,
                stay_logged: self.login.stay_logged
            }

            if (this.isCaptcha) {
                const recaptchaSecret = process.env.VUE_APP_RECAPTCHA_SECRET

                // eslint-disable-next-line no-undef
                grecaptcha.ready(function() {
                    // eslint-disable-next-line no-undef
                    grecaptcha
                        .execute(process.env.VUE_APP_RECAPTCHA_SITE_KEY, {
                            action: 'submit'
                        })
                        .then(async token => {
                            var requestString = `${process.env.VUE_APP_API}verify_captcha/${recaptchaSecret}/${token}`

                            const captchaResponse = await axios.post(
                                requestString
                            )
                            const captchaSuccess =
                                captchaResponse.data.message.success

                            if (captchaSuccess) {
                                self.$store.dispatch('authLogin', {
                                    requestBody
                                })
                            } else {
                                self.$store.dispatch('addNotification', {
                                    type: 'danger',
                                    content:
                                        'Wystąpił błąd. Spróbuj ponownie później.'
                                })
                            }
                        })
                })
            } else {
                self.$store.dispatch('authLogin', {
                    requestBody
                })
            }
        },
        checkAnimation(e) {
            if (e.animationName === 'onAutoFillStart') {
                this.autofilled = true
            } else if (e.animationName === 'onAutoFillCancel') {
                this.autofilled = false
            }
        }
    }
}
</script>
